import { render, staticRenderFns } from "./client-upload-pc.vue?vue&type=template&id=a5030306&scoped=true&"
import script from "./client-upload-pc.vue?vue&type=script&lang=js&"
export * from "./client-upload-pc.vue?vue&type=script&lang=js&"
import style0 from "./client-upload-pc.vue?vue&type=style&index=0&id=a5030306&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5030306",
  null
  
)

export default component.exports